"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogoutEndpoint = exports.createSignUpEndpoint = exports.createRevokeEndpoint = exports.createTokenEndpoint = exports.createAuthorizeEndpoint = void 0;
const createAuthorizeEndpoint = (domain, urlSearchParams) => new URL(`https://${domain}/oauth2/authorize?${urlSearchParams.toString()}`).toString();
exports.createAuthorizeEndpoint = createAuthorizeEndpoint;
const createTokenEndpoint = (domain) => new URL(`https://${domain}/oauth2/token`).toString();
exports.createTokenEndpoint = createTokenEndpoint;
const createRevokeEndpoint = (domain) => new URL(`https://${domain}/oauth2/revoke`).toString();
exports.createRevokeEndpoint = createRevokeEndpoint;
const createSignUpEndpoint = (domain, urlSearchParams) => new URL(`https://${domain}/signup?${urlSearchParams.toString()}`).toString();
exports.createSignUpEndpoint = createSignUpEndpoint;
const createLogoutEndpoint = (domain, urlSearchParams) => new URL(`https://${domain}/logout?${urlSearchParams.toString()}`).toString();
exports.createLogoutEndpoint = createLogoutEndpoint;
